<template>
  <form ref="form" @submit.prevent="$emit('submit')">
    <slot />
    <div v-if="globalErrorMessage !== ''" class="error-input my-2">
      {{ globalErrorMessage }}
    </div>
    <slot name="actions"></slot>
  </form>
</template>
<script>
export default {
  name: "BaseForm",
  data() {
    return {
      globalErrorMessage: ""
    };
  },
  methods: {
    reset() {
      this.resetArray(this.$slots.default);
    },
    resetArray(arrayComponents) {
      arrayComponents.forEach(item => {
        if (item?.componentInstance && "reset" in item.componentInstance) {
          item.componentInstance.reset();
        } else {
          if (item?.children?.length > 0) {
            this.resetArray(item.children);
          }
        }
      });
    },
    validate() {
      this.globalErrorMessage = "";
      let valid = true;
      if (!this.validateArray(this.$slots.default)) {
        valid = false;
      }
      return valid;
    },
    addError(errorMessage) {
      this.globalErrorMessage = errorMessage;
    },
    validateArray(arrayComponents) {
      let valid = true;
      arrayComponents.forEach(item => {
        if (item?.componentInstance && "validate" in item.componentInstance) {
          if (!item.componentInstance.validate()) {
            valid = false;
          }
        } else {
          if (item?.children?.length > 0) {
            if (!this.validateArray(item.children)) {
              valid = false;
            }
          }
        }
      });
      return valid;
    }
  }
};
</script>
